import API from "./base.service";

export const fetchCompanies = async (payload) => {
  try {
    const res = await API.get("/companies", {
      params: payload,
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const fetchForSuppliersCompanies = async (payload) => {
  try {
    const res = await API.get("/companies/for-supplier", {
      params: payload,
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const fetchCompanyById = async (companyId) => {
  try {
    const res = await API.get(`/companies/${companyId}`);
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyStatus = async (companyId, isActive) => {
  try {
    const res = await API.put(`/companies/manage-by-superadmin/${companyId}`, {
      is_active: isActive,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const createCompanyWithDocuments = async (formData) => {
  try {
    const res = await API.post(`/companies/vendor`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const sendInviteCompany = async (companyId, email) => {
  try {
    const res = await API.post(`/companies/invite-send-by-supplier`, {
      email,
      company_id: companyId,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const fetchSupplierInvites = async (payload) => {
  try {
    const res = await API.get(`/companies/get-supplier-invitation`, {
      params: payload,
    });
    return res;
  } catch (error) {
    throw error;
  }
};
export const fetchFleetInvites = async (payload) => {
  try {
    const res = await API.get(`/companies/get-fleet-invitation`, {
      params: payload,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const updateSupplierInviteStatus = async (inviteId, status) => {
  try {
    const res = await API.post(`/companies/accept-invite-by-fleet-admin/`, {
      supplier_invitation_id: inviteId,
      status,
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export const deleteSupplierInvite = async (inviteId, isSupplier) => {
  try {
    const url = !isSupplier
      ? "removeConnectedCompanies"
      : "leaveConnectedSuppliers";
    const companyIds = [inviteId.company.id];
    const supplierIds = [inviteId.send_by.id];

    // Construct data based on isSupplier
    const data = !isSupplier ? { companyIds } : { supplierIds };

    // Send the PATCH request with the data
    const res = await API.patch(`/companies/${url}`, data);

    return res;
  } catch (error) {
    throw error;
  }
};
